import MapMenu from '../lib/map_menu';
import UiInteraction from '../lib/ui_interaction';

export default class DiningLayer {
	constructor() {
		this.checkboxEl = document.getElementById('dining-layer');
		this.visible = false;
	}

	add() {
		const url = W.api_root + 'dining_locations.geojson';
		if (!W.map.getSource('dining-source')) {
			W.map.addSource('dining-source', {
				type: 'geojson',
				data: url,
			});
		}

		W.map.addLayer({
			id: 'dining-layer',
			type: 'symbol',
			source: 'dining-source',
			layout: {
				'icon-image': 'marker-dining',
				'icon-offset': [0, 0],
				'icon-anchor': 'bottom',
				'icon-size': 1.5,
				'icon-allow-overlap': true,
				'icon-ignore-placement': true,
			},
		});

		this.visible = true;
		W.LayerUtils.setView('dining-layer');
		MapMenu.hide();
	}

	remove() {
		W.map.removeLayer('dining-layer');
		UiInteraction.clearAllPopups();
		this.visible = false;
	}
}
